import { render, staticRenderFns } from "./Kb1.vue?vue&type=template&id=11e6dc67&scoped=true&"
import script from "./Kb1.vue?vue&type=script&lang=js&"
export * from "./Kb1.vue?vue&type=script&lang=js&"
import style0 from "./Kb1.vue?vue&type=style&index=0&id=11e6dc67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e6dc67",
  null
  
)

export default component.exports